const cart = {
    state: {
        products: [],
        Race:localStorage.getItem('Race') || '',
    },
    mutations: {
        ADD_PRODUCT(state, product) {   
            state.products.push(product);
           
            
        },
        INCREMENT_PRODUCT_COUNT(state, index) {
            state.products[index].quantity += 1;
        },
        REMOVE_PRODUCT(state, product) {
            let index = state.products.findIndex((item) => product.kala === item.kala)
            if (index > -1) {
                if (state.products[index].quantity > 0) {
                    state.products[index].quantity -= 1;
                    if (state.products[index].quantity === 0) {
                        state.products[index].description = '';
                        state.products.splice(index, 1)
                    }
                }
            }
        },
        ADD_DESCRIPTION(state, {product, description}) {
            let index = state.products.findIndex((item) => product.kala === item.kala)
            if (state.products[index].description === undefined) {
                state.products[index].description = '';
            }
            state.products[index].description += description + ' ';
        },
        EMPTY_CART(state) {
            state.products = []
        },
        EDIT_CART(state, products) {
            state.products = products
        }
    },
    actions: {
        /* we check the validation in action so we can return Promise.reject() on error (we cant use promise in mutations)*/
        addProduct({commit, state, getters}, product) {
            let index = state.products.findIndex((item) => product.kala === item.kala)
            console.log(index)
            // Does product Already exist in Cart => increment count
            if (index > -1) {
                // is Product type == Reduction ==> check total reduction limit
                if (product.isNegative === -1) {
                    if ((product.kasriType === 'Service' && state.products[index].quantity + 1 > getters.countOfServiceProducts)
                        || (product.kasriType === 'Rice' && state.products[index].quantity + 1 > getters.countOfRiceProducts)) {
                        return Promise.reject(`بیشتر از سفارش نمیتوان کسری اضافه کرد.`)
                    } else {
                        commit('INCREMENT_PRODUCT_COUNT', index)
                    }
                } else {
                    // Check Inventory First Before Adding More
                    if (state.products[index].quantity + 1 > product.mojodi) {
                        return Promise.reject(`موجودی این کالا ${product.mojodi} عدد است.`)
                    } else {
                        commit('INCREMENT_PRODUCT_COUNT', index)
                        // if (tag == 1) ==> We need to get a description for this product
                        if (product.isTag === 1) {
                            return Promise.resolve("getDescription")
                        }
                    }
                }
                // is this new Product ==> add it to cart
            } else {
                product.quantity = 0;
                // is Product type == Reduction ==> check total reduction limit
                if (product.isNegative === -1) {
                    if ((product.kasriType === 'Service' && getters.countOfServiceProducts > 0)
                        || (product.kasriType === 'Rice' && getters.countOfRiceProducts > 0)) {
                        product.quantity = 1;
                        commit('ADD_PRODUCT', product)
                    } else {
                        return Promise.reject(`بیشتر از سفارش نمیتوان کسری اضافه کرد.`)
                    }
                } else {
                    if (product.quantity + 1 > product.mojodi) {
                        return Promise.reject(`موجودی این کالا ${product.mojodi} عدد است.`)
                    } else {
                        product.quantity = 1;
                        commit('ADD_PRODUCT', product)
                        // if (tag == 1) ==> We need to get a description for this product
                        if (product.isTag === 1) {
                            return Promise.resolve("getDescription")
                        }
                    }
                }
            }
        },
        removeProduct({commit}, product) {
            commit('REMOVE_PRODUCT', product)
        },
        addDescription({commit}, {product, description}) {
            commit('ADD_DESCRIPTION', {product, description})
        },
        emptyCart({commit, dispatch}) {
            commit('EMPTY_CART')
            dispatch('removeFactor')
        },
        editCart({commit}, products) {
            commit('EDIT_CART', products)
        }
    },
    getters: {
        productCount: state => id => {
            const product = state.products.find(product => product.kala === id)
            if (product) {
                return product.quantity
            }

            return 0;
        },
        productDescription: state => id => {
            const product = state.products.find(product => product.kala === id)
            if (product) {
                return product.description
            }

            return '';
        },
        countOfRiceProducts(state) {
            return state.products.reduce((count, product) =>
                    product.hasRace ? count + product.quantity : count,
                0)
        },
        countOfServiceProducts(state) {
            return state.products.reduce((count, product) =>
                    product.hasService ? count + product.quantity : count,
                0)
        },
        countOfFoodProducts(state) {
            return state.products.reduce((count, product) =>
                    product.kindFood !== -1 ? count + product.quantity : count,
                0)
        },
        isCartEmpty(state) {
            return state.products.length === 0
        },
        totalPrice(state) {
            return state.products.reduce((totalPrice, product) =>
                    totalPrice += product.nerkh_With_Maliat * product.isNegative * product.quantity / 10
                , 0)
        },
        totalCount(state) {
            return state.products.length
        }
    }
}

export default cart;
